/**
 * 将未读消息上报为已读
 *
 * 途径：
 * 1. 接收到服务器推过来的消息，且页面可见
 * 2. 页面通过 webview 嵌入到 APP 时，页面可见的 API 可能失效，故增加点击时的判断
 */

import get from 'lodash.get'
import debounce from 'lodash.debounce'
import { MESSAGE_FROM } from '@/constants/message'
import {
    pageVisibility
} from '@/utils/dom'
import { postMessageRead } from '@/api/chat'

const {
    PAGE_HIDDEN,
    visibilityChange,
    isSupportVisibilityChange
} = pageVisibility
const DEBOUNCE_TIME = 1000 // 点击上报消息已读的频率

// 正在请求已读的消息 postingIdsFromServer，避免重复提交
const postingIdsFromServer = {
    idsFromServer: new Set(),
    /**
     * @param { String[] } unreadMessage - idFromServer
     */
    add (unreadMessage) {
        // unpostIdsFromServerInLocalStorage.add(unreadMessage)
        unreadMessage.forEach(idFromServer => {
            this.idsFromServer.add(idFromServer)
        })
    },
    remove (unreadMessage) {
        // unpostIdsFromServerInLocalStorage.remove(unreadMessage)
        unreadMessage.forEach((idFromServer) => {
            this.idsFromServer.delete(idFromServer)
        })
    },
    /**
     * @param { String } idFromServer
     */
    has (idFromServer) {
        return this.idsFromServer.has(idFromServer)
    },
    clear () {
        this.idsFromServer.clear()
    }
}

// 若启用本地兜底，需要前后端校验当前 uid 是否是上次的 uid，若不是则会导致串数据
/* const UNPOST_IDS_FROM_SERVER = 'unpost_ids_from_server'
const unpostIdsFromServerInLocalStorage = {
    idsFromServer: new Set(),

    add (unreadMessage) {
        unreadMessage.forEach(idFromServer => {
            this.idsFromServer.add(idFromServer)
        })
        this.save()
    },
    remove (unreadMessage) {
        unreadMessage.forEach(idFromServer => {
            this.idsFromServer.delete(idFromServer)
        })
        this.save()
    },
    save () {
        window.localStorage.setItem(UNPOST_IDS_FROM_SERVER, JSON.stringify([...this.idsFromServer]))
    },
    initFromLocalStorage () {
        const localStorageValue = window.localStorage.getItem(UNPOST_IDS_FROM_SERVER)
        const localStorageIds = localStorageValue
            ? JSON.parse(localStorageValue)
            : []
        return this.idsFromServer = new Set(localStorageIds)
    },
    // @returns { String[] }
    get () {
        try {
            this.initFromLocalStorage()
        } catch (err) {
            // eslint-disable-next-line
            console.error(err)
        }
        return [...this.idsFromServer]
    },
    clear () {
        this.idsFromServer.clear()
        this.save()
    }
} */

export default {
    data () {
        return {
            setMessageReadDebounced: debounce(this.setMessageRead, DEBOUNCE_TIME, {
                leading: true,
                trailing: false
            }),
            visibilitychangeHandleSelf: this.visibilitychangeHandle.bind(this)
        }
    },
    methods: {
        bindUnreadEvents () {
            if (isSupportVisibilityChange) {
                document.addEventListener(
                    visibilityChange,
                    this.visibilitychangeHandleSelf,
                    false
                )
            }
        },
        unbindUnreadEvents () {
            if (isSupportVisibilityChange) {
                document.removeEventListener(
                    visibilityChange,
                    this.visibilitychangeHandleSelf,
                    false
                )
            }
        },
        visibilitychangeHandle () {
            // 页面可见
            if (!document[PAGE_HIDDEN]) {
                this.setMessageRead()
            }
        },
        /* async postLastUnPostMessage () {
            const idsFromServerInLocalStorage = unpostIdsFromServerInLocalStorage.get()
            const unreadAndUnPostingMessage = this.getUnreadAndUnPostingMessage()
            const idsFromServer = idsFromServerInLocalStorage.filter(idFromServer => {
                return !unreadAndUnPostingMessage.find(message => message.idFromServer === idFromServer)
            })
            if (idsFromServer.length === 0) {
                return
            }
            try {
                await postMessageRead(idsFromServer)
                unpostIdsFromServerInLocalStorage.clear()
            } catch (err) {
                // eslint-disable-next-line
                console.error(err)
                // 需要对报错的情况做处理，如消息不属于该 uid 时需要清空 localStorage，否则死循环
            }
        }, */
        getUnreadAndUnPostingMessage () {
            return this.messageList
                .filter(message => {
                    return message.baseProps.isUnread == false
                        && get(message, 'server.from') === MESSAGE_FROM.USER
                        // && !postingIdsFromServer.has(message.server.id)
                })
                .map(message => message.server.id)
        },
        async setMessageRead () {
            const toPostMessage = this.getUnreadAndUnPostingMessage()
            if (toPostMessage.length === 0) {
                return
            }
            try {
                // 对于 nested 消息类型，存在多个 idFromServer 相同的情况，但 post 的时候只需一个
                const uniqueToPostMessage = [...new Set(toPostMessage)]
                postingIdsFromServer.add(uniqueToPostMessage)
                await postMessageRead(uniqueToPostMessage)
                // 对于 nested 消息类型，存在多个 idFromServer 相同的情况
                toPostMessage.forEach(idFromServer => {
                    this.setMessageValueByIdFromServer(idFromServer, 'baseProps.isUnread', false)
                })
            } catch (err) {
                // eslint-disable-next-line
                console.error(err)
            }
            postingIdsFromServer.remove(toPostMessage)
        }
    },
    beforeDestory () {
        this.unbindUnreadEvents()
        postingIdsFromServer.clear()
    }
}
